
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import About from './pages/About';
import reportWebVitals from './reportWebVitals';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Departments from './pages/Departments';
import OurTeams from './pages/OurTeams';
import News from './pages/News';
import SoftwareDevelopment from './pages/SoftwareDevelopment';
import GraphicDesign from './pages/GraphicDesign';
import NewsPage from './pages/NewsPage';
import Isp_page from './pages/IspPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/departments" element={<Departments />} />
        <Route path="/ourteams" element={<OurTeams/>}/>
        <Route path="/newspage" element={<NewsPage/>}/>
        <Route path="/softwaredevelopment" element={<SoftwareDevelopment/>}/>
        <Route path="/graphicdesign" element={<GraphicDesign/>}/>
        <Route path="/isp" element={<Isp_page/>} />
        
        
      </Routes> 
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
